export default __webpack_public_path__ + "static/media/Services-Two.d6a9a94a.svg";